export default () => `
	<p class="phaeno-calendar__loading">Fehler beim Laden</p>
`;
